<template>
  <div class="media-wrapper" :class="!canAccess ? 'muted' : '' " v-if="!(isProcessing && !edit)">
    <mu-divider v-if="!edit || simple" class="divider-padding"/>
    <!--
    <transition name="fade">
      <div v-if="!simple && completionFetched && isPreview" class="mobile-hide float-right">
        <loading-progress
          :progress="progress"
          shape="line"
          size="100"
          width="100"
          height="10"
          />
        <div class="progress-text">{{ stringCompleted }}%</div>
        <div v-if="isQuizProgressShow && media.submitted">
          <loading-progress
              :progress="questionProgress"
              shape="line"
              size="100"
              width="100"
              height="10"
              />
          <div class="progress-text">{{ $t('question.score') + ' ' + questionPercentage }}%</div>
        </div>
      </div>
    </transition>
    !-->
    <div class="float-right" v-if="edit">
      <div class="text-align-right">
        <ManageMedia 
          v-model="data" 
          :deleting="deleting" 
          :editing="editing" 
          :access="access"
          :thumbnail="thumbnail"
          :subtitle="editingSubtitle"
          :enrollments="enrollments"
          :title="$t('button.edit') + $t('space') + $t('media.title')"
          :type="data.type"
          @cancel="onCancel"
          @save="onSave"
          @thumbnail="onThumbnail"
          @subtitle="onSubtitle"
          @delete="onDelete"
          >
          <ButtonOrListGroup :simple="simple">
            <template slot="list">
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="edit" 
                color="primary" 
                @click="editing = true" 
                :text="$t('button.edit') + $t('space') + $t('media.title')"
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                v-if="data.hasOwnProperty('volatility') && data.volatility"
                :simple="simple"
                small 
                icon="list" 
                color="primary" 
                @click="toRoute('Volatility')" 
                :text="$t('button.edit') + $t('space') + $t('media.volatilityRecord')"
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="subtitles" 
                color="primary" 
                @click="editingSubtitle = true" 
                :text="$t('button.edit') + $t('space') + $t('media.subtitle')"
                :disabled="!isSubtitleEditable"
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="photo" 
                color="primary" 
                @click="thumbnail = true" 
                :text="$t('button.edit') + $t('space') + $t('media.thumbnail')" 
                :disabled="!isThumbnailEditable"
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="person_add" 
                color="secondary" 
                @click="access = true" 
                :text="$t('button.access')" 
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="delete" 
                color="secondary" 
                @click="deleting = true" 
                :text="$t('button.delete')" 
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="question_answer" 
                color="success" 
                @click="toRoute('Quiz')" 
                :text="$t('button.manage') + $t('space') + $t('question.title')" 
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="bar_chart" 
                color="secondary" 
                @click="toRoute('Submission')" 
                :text="$t('submission.title')" 
                :class="isProcessing ? 'muted' : ''"
                />
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="local_offer" 
                color="success" 
                @click="toRoute('Tag')" 
                :text="$t('button.manage') + $t('space') + $t('tag.title')" 
                :class="isProcessing ? 'muted' : ''"
                />
              <!--
              <ButtonOrListItem 
                :simple="simple"
                small 
                icon="picture_in_picture" 
                color="success" 
                @click="toRoute('Overlay')" 
                :text="$t('button.manage') + $t('space') + $t('overlay.title')" 
                :disabled="!isOverlayEnabled"
                :class="isProcessing ? 'muted' : ''"
                />
              !-->
            </template>
          </ButtonOrListGroup>
        </ManageMedia>
      </div>
    </div>
    <div class="display-flex" :class="isProcessing ? 'muted' : ''">
      <div class="media-thumbnail">
        <div v-if="isProcessing">
          <mu-circular-progress :size="40" />
        </div>
        <div v-else-if="edit && !simple">
          <mu-avatar color="transparent" :text-color="themeTextColor">
            <mu-icon 
              class="drag-handle"
              value="open_with"
            /> 
          </mu-avatar>
        </div>
        <div v-else>
          <mu-avatar v-if="this.data._id === mediaId" :color="simple ? ( this.data._id === mediaId ? 'secondary' : 'primary') : 'transparent'" :text-color="simple ? '' : themeTextColor" class="inline-icon">
            <mu-icon value="play_arrow" />
          </mu-avatar>
          <div class="img-crop full-width ratio" v-else-if="isThumbnailShow">
            <img class="img-thumbnail full-width full-height" :src="thumbnailSource">
          </div>
          <mu-avatar :color="simple ? ( this.data._id === mediaId ? 'secondary' : 'primary') : 'transparent'" :text-color="simple ? '' : themeTextColor" v-else class="inline-icon">
            <mu-icon value="format_size" v-if="this.data.type === 'wysiwyg'" />
            <mu-icon value="layers" v-else-if="isModel" />
          </mu-avatar>
        </div>
      </div>
      <div class="media-info-wrapper"> 
        <div class="display-flex align-items-center">
          <span class="media-title-link" @click="onClickMedia" :class="simple ? '' : 'item-title'">
            {{data.name}}
            <span v-if="isDurationShow">({{time}})</span>
          </span>
          <BookmarkButton 
            :id="data._id"
            type="media"
            :object="data"
            small
            />
          <div class="tags-wrapper">
            <ShareMedia 
              v-model="data" 
              :sharing="sharing" 
              :title="$t('button.share')"
              @cancel="onCancel"
              v-if="!simple"
              >
              <mu-button small icon @click.stop.prevent="sharing = true">
                <mu-icon value="share"></mu-icon>
              </mu-button>
            </ShareMedia>
            <mu-button small icon @click.stop.prevent="onDownload" v-if="isDownloadable">
              <mu-icon value="get_app"></mu-icon>
            </mu-button>
          </div>
        </div>
        <div class="description-wrapper wordwrap">
          <small>{{data.description}}</small>
        </div>
        <div v-if="!simple">
          <mu-button small icon @click="editingTags = !editingTags" v-if="edit && !editingTags">
            <mu-icon value="flag" />
          </mu-button>
          <span v-if="!editingTags">
            <span v-if="isTagsExist">
              <Tag :text="tag" v-for="(tag, index) in data.tags" :key="index" :index="index" :canDelete="false" />
            </span>
          </span>
          <TagInput v-model="data.tags" v-else @onSubmit="editingTags = false"/>
        </div>
        <div v-else>
          <span v-if="isTagsExist">
            <Tag :text="tag" v-for="(tag, index) in data.tags" :key="index" :index="index" :canDelete="false" />
          </span>
        </div>
      </div>
    </div>
    <div class="clearfix" />
  </div>
</template>

<script>
import theme from '@/mixins/theme.js'
import media from '@/mixins/media.js'
import timeFormatter from '@/utils/timeFormatter.js'

import ManageMedia from '@/components/Media/ManageMedia'
import ShareMedia from '@/components/Media/ShareMedia'
import BookmarkButton from '@/components/Bookmark/Button'

import TagInput from '@/components/Common/Tag/TagInput'
import Tag from '@/components/Common/Tag/Tag.vue'

import ButtonOrListItem from '@/components/Common/ButtonOrListItem'
import ButtonOrListGroup from '@/components/Common/ButtonOrListGroup'

import axios from "axios";
import mime from 'mime-types'

export default {
  name: "MediaItem",
  mixins: [theme, media],
  components: {
    ManageMedia,
    TagInput,
    Tag,
    ShareMedia,
    ButtonOrListItem,
    ButtonOrListGroup,
    BookmarkButton,
  },
  props: {
    obj: Object,
    editable: Boolean,
    enrollments: {
      type: Array,
      default() {
        return [];
      }
    },
    simple: {
      type: Boolean,
      default: false
    },
    mediaId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      data: JSON.parse(JSON.stringify(this.obj.obj)),
      editing: false,
      deleting: false,
      access: false,
      thumbnail: false,
      sharing: false,
      
      editingTags: false,
      editingSubtitle: false,
      
      completion: {},
      completionFetched: false,
    }
  },
  computed: {
    // From Store
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    
    // Flag
    edit() {
      return !this.isPreview && this.editable;
    },
    canAccess() {
      if(
        !this.data.hasOwnProperty('access_mode') || 
        this.data.access_mode === 0 || 
        this.editable
      ) { // Enrolled access mode
        return true;
      } else { // Whitelist access mode
        if(
          this.data.hasOwnProperty('access_whitelist') && 
          Array.isArray(this.data.access_whitelist)
        ) { // Valid Whitelist
          return this.data.access_whitelist.includes(this.$store.state.auth.user._id);
        } else {
          return false;
        }
      }
    },
    isProcessing() {
      return this.data.hasOwnProperty('processing') && this.data.processing;
    },
    
    // Helper
    time() {
      return timeFormatter(this.data.duration);
    },
    // Progress
    progress() {
      return this.completion.completion;
    },
    progressPercentage() {
      return Math.round(this.progress * 100);
    },
    questionProgress() {
      return this.completion.question_correct / this.completion.question_total;
    },
    questionPercentage() {
      return Math.round(this.questionProgress * 100);
    },
      
    stringCompleted() {
      if(this.data.type === 'video' || this.data.type === 'youtube' || this.data.type === 'mp4link') {
        return this.$t('channel.video_completed') + ' ' + this.progressPercentage;
      } else {
        return this.$t('channel.completed') + ' ' + this.progressPercentage;
      }
    },
  },
  watch: {
    obj: {
      handler(newValue) {
        if(newValue) {
          this.data = JSON.parse(JSON.stringify(this.obj.obj))
        }
      },
      deep: true
    },
    editingTags(newValue) {
      if(!newValue) {
        let formData = new FormData();
        formData.append('tags', this.data.tags);
        this.onSaveJson(this.data);
      }
    },
    triggerRefresh() {
      this.$emit('updated');
    },
  },
  mounted() {
    this.$nextTick(() => {
      if(!this.simple) {
        this.fetchCompletion();
      }
    });
  },
  methods: {
    fetchCompletion() {
      if(!this.editable) {
        axios.get(this.$store.getters.urlApi + "media/" + this.obj.id + '/completion', {
          headers: {
            token: this.$store.state.auth.token
          }
        }).then(response => {
          this.completion = response.data.data
          this.completionFetched = true;
        });
      }
    },
    
    // Event
    onCancel() {
      this.editing = false;
      this.deleting = false;
      this.access = false;
      this.thumbnail = false;
      this.sharing = false;
      this.editingSubtitle = false;
    },
    onSave(payload) {
      this.editing = false;
      this.deleting = false;
      this.access = false;
      this.thumbnail = false;
      if(payload.hasOwnProperty('upload')) {
        this.onSaveFormData(payload);
      } else {
        this.onSaveJson(payload);
      }
    },
    onSaveJson(payload) {
      axios.put(this.$store.getters.urlApi + "media/" + this.obj.id, payload, {
        headers: {
          token: this.$store.state.auth.token
        },
      }).then(() => {
        this.$toast.success(this.$t('toast.edit'));
        this.$emit('updated');
      });
    },
    onSaveFormData(payload) {
      this.editing = false;
      this.deleting = false;
      this.access = false;
      
      var formData = payload.file;
      var data = payload.data;
      formData.append('_method', "PUT");
      var upload = payload.upload;
      if(upload) {
        this.$store.commit('uploadQueueAppend', {
          uploadId: Math.random().toString(36).substring(7),
          formData: formData,
          url: "media/" + this.data._id,
          text: formData.get('name')
        });
      } else {
        axios.put(this.$store.getters.urlApi + "media/" + this.obj.id, data, {
          headers: {
            token: this.$store.state.auth.token
          }
        }).then(res => {
          this.$toast.success(this.$t('toast.edit'));
          this.$emit('updated');
        });
      }
    },
    onThumbnail(formData) {
      this.thumbnail = false;
      
      axios.post(this.$store.getters.urlApi + "media/" + this.obj.id + "/thumbnail", formData, {
        headers: {
          token: this.$store.state.auth.token
        },
      }).then(() => {
        this.$toast.success(this.$t('toast.edit'));
        this.$emit('updated');
      });
    },
    onSubtitle(formData) {
      this.editingSubtitle = false;
      
      axios.post(this.$store.getters.urlApi + "media/" + this.obj.id + "/subtitles", formData, {
        headers: {
          token: this.$store.state.auth.token,
          'Content-Type': 'multipart/form-data'
        },
      }).then(() => {
        this.$toast.success(this.$t('toast.edit'));
        this.$emit('updated');
      });
    },
    onDelete() {
      this.editing = false;
      this.deleting = false;
      axios.delete(this.$store.getters.urlApi + "media/" + this.obj.id, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(() => {
        this.$toast.success(this.$t('toast.delete'));
        this.$emit('deleted');
      });
    },
    onSort() {
      this.$emit('sort');
    },
    onDownload() {
      var link = document.createElement("a");
      link.download = this.data.name + '.' + mime.extension(mime.lookup(this.data.content));
      link.href = this.data.content;
      link.setAttribute('target','_blank');
      link.click();
    },
    onClickMedia() {
      if(this.canAccess) {
        this.$router.push({
          name: 'Media',
          params: {
            mediaId: this.obj.id
          }
        });
      }
    },
    
    // Helper
    toRoute(name) {
      this.$router.push({
        name: name,
        params: {
          mediaId: this.obj.id,
          fromChannel: !this.simple
        }
      });
    },
  }
};
</script>

<style scoped>
.media-wrapper {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 2px;
  padding-top: 2px;
}
.description-wrapper {
  margin-left: 2px;
}
.muted {
  opacity: 0.4;
  pointer-events: none;
}
.img-thumbnail {
  object-fit: cover;
  object-position: top;
}
.media-thumbnail  {
  max-width: 40px;
}
.img-crop {
  overflow: hidden;
}
.img-crop.ratio {
  padding-top: 50%;
}
.img-crop.ratio img {
  margin-top: -125%;
  margin-bottom: -25%;
}
.media-title-link:hover {
  color: #999;
  cursor: pointer;
}
.divider-padding {
  margin-top: 4px;
  margin-bottom: 4px;
}
.media-info-wrapper {
  padding-left: 4px;
}
.unmuted {
  pointer-events: auto;
}
</style>